import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
//Components
import { NotFound } from "@uaveiro/ui";
import { baseUrl, portalAPI } from "../../services/constants";

const NotFoundTemplate = ({ history, ...props }) => {
  const hasHistory = useMemo(
    () => history !== undefined && history.location.state !== undefined,
    [history]
  );
  const historyProps = useMemo(
    () => (hasHistory ? { ...history.location.state } : {}),
    [hasHistory, history]
  );
  const url = useMemo(
    () =>
      hasHistory
        ? `${baseUrl}${history.location.state.location}`
        : typeof window !== "undefined"
        ? `${window.location.protocol}//${
            window.location.hostname
          }${localStorage.getItem("portalLastLocationPath")}`
        : null,
    [hasHistory, baseUrl]
  );

  const onSendError = async () => {
    const page = "Ups! Página não encontrada";

    const info = `url: ${url}`;

    await fetch(
      `${portalAPI}/teams/message?page=${page}&info=${info}&code=404`,
      {
        method: "POST"
      }
    );
  };
  useEffect(() => {
    onSendError();
  }, []);

  const notFoundProps = {
    description: {
      url,
      ...historyProps
    },
    ...props
  };

  return <NotFound {...notFoundProps} />;
};

NotFoundTemplate.propTypes = {
  history: PropTypes.object.isRequired
};

export default withRouter(NotFoundTemplate);
